module.exports = __webpack_public_path__ + "img/account-meta5.60d3edda.png";